module.exports = __webpack_public_path__ + "static/media/A3.e72c7397.pdf";